var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"internal-link link-highlight",attrs:{"href":_vm.fullLinkHref,"target":"_blank"}},[_vm._v(_vm._s(_vm.internalLinkTitle))])}
var staticRenderFns = []
export { render, staticRenderFns }